const spriteFox = {
    id: 1,
    title: `SpriteFox`,
    description: `A collaborative editor where people can come together to create and animate sprites with the use of Canvas and Socket.io.`,
    role: `Fullstack Developer`,
    deployedLink: `https://spritefox.herokuapp.com/`,
    githubLink: `https://github.com/Lunch-Box-of-Culture/SpriteFox`,
    projectImage: `/images/projectImages/spritefox.png`,
}

const strawberryShopper = {
    id: 2,
    title: `Strawberry Shopper`,
    description: `A Sales Website for all your Strawberry Needs`,
    role: `Fullstack Developer`,
    deployedLink: `http://strawberry-shopper.herokuapp.com/`,
    githubLink: `https://github.com/2003-Spectacular-Strawberries/Strawberry-Shopper`,
    projectImage: `https://hips.hearstapps.com/clv.h-cdn.co/assets/15/22/2560x1728/gallery-1432664914-strawberry-facts1.jpg?resize=768:*`,
}

const spellBook = {
    id: 3,
    title: `Spellbook`,
    description: `A Spell Manager for DND 5th edition`,
    role: `Fullstack Developer`,
    deployedLink: ``,
    githubLink: `https://github.com/edwardhaddican/Spellbook_V2`,
    projectImage: `/images/projectImages/spellbookImage.jpeg`,
}

const cuteAnimalAPI = {
    id: 4,
    title: `Cute Animal API`,
    description: `An API of cute animals (soon to have a front end app)`,
    role: `Fullstack Developer`,
    deployedLink: ``,
    githubLink: `https://github.com/edwardhaddican/cuteAnimalAPI`,
    projectImage: `https://s.abcnews.com/images/Lifestyle/ht_pudding_the_fox_03_mt_140821_16x9_992.jpg`,
}

const carpathiaHouseSite = {
    id: 5,
    title: `Carpathia House Site`,
    description: `A home site for House Carpathia`,
    role: `Fullstack Developer`,
    deployedLink: `https://carpathia.herokuapp.com/home`,
    githubLink: `https://github.com/edwardhaddican/CarpathiaHouseSite`,
    projectImage: `https://res.cloudinary.com/dwjilsieu/image/upload/v1655137425/CarpathiaHouseArms_ef4yfb.png`,
}

const wrathAndGloryAPI = {
    id: 6,
    title: `Wrath and Glory API`,
    description: `An API of data to accompany the Wrath and Glory Rule book`,
    role: `Backend Developer`,
    deployedLink: `https://obscure-wave-78111.herokuapp.com/`,
    githubLink: ``,
    projectImage: `https://upload.wikimedia.org/wikipedia/commons/b/bb/For_the_love_of_waaagh_by_grundalug.jpg`,
}

const wrathAndGloryFrontend = {
    id: 7,
    title: `Wrath and Glory Frontend`,
    description: `A small site to display the data from the Wrath and Glory API.  This is meant to accompany the Wrath and Glory Rule book`,
    role: `Frontend Developer`,
    deployedLink: `https://wrath-and-glory-dashboard.herokuapp.com/`,
    githubLink: ``,
    projectImage: `https://res.cloudinary.com/dwjilsieu/image/upload/v1655137085/orkImageForFavicon_htipyd.png`,
}

const cuteAnimalFrontend = {
    id: 8,
    title: `Cute Animal and Quote app`,
    description: `An upbeat app to see a cute animal and a quote`,
    role: `Fullstack Developer`,
    deployedLink: `https://young-plateau-45953.herokuapp.com/`,
    githubLink: `https://github.com/edwardhaddican/cuteAnimalQuoteApp`,
    projectImage: `https://res.cloudinary.com/dwjilsieu/image/upload/v1655137777/hqdefault_bmc9na.jpg`,
}

const allProjectData = [
    carpathiaHouseSite,
    cuteAnimalAPI,
    cuteAnimalFrontend,
    spellBook,
    strawberryShopper,
    spriteFox,
    wrathAndGloryAPI,
    wrathAndGloryFrontend,
]

export default allProjectData
